import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { concatMap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { AppMetadataHandler } from 'app';

@Component({
  selector: 'app-demo-claims-details',
  templateUrl: 'demo-claims-details.component.html',
  styleUrls: ['demo-claims-details.component.scss']
})

export class DemoClaimsDetailsComponent implements OnInit {

  productType: string = "claims-life";
  productTypeConfig: any = {}; // Set via switchProduct()
  state:string = 'adjudication'; /* Set default view here */
  stateName:string = "Adjudication"; /* Proper name for the view */
  tempState:string = 'adjudication'; /* holds temp val while showing `loading...` info (THIS IS FAKE: FOR DEMO ALONE) */

  permissions: any = [];

  constructor(
      private message: NzMessageService,
      private modalService: NzModalService,
      private route: ActivatedRoute,
      private router: Router,
      public appMetadataHandler: AppMetadataHandler
  ) {

    /* TEMP DEMO CODE */
    /* Set State (If passed from other routes. Eg: New Intimation) */
    let newState = this.route.snapshot.paramMap.get('from');
    this.productType = this.route.snapshot.paramMap.get('product') || this.productType;
    if(!newState) newState = this.state;
    this.tempState = newState;
    this.switchProduct(this.productType);
    this.processStateVars(newState);
    this.handleStateChange(newState);
    console.log("[state] -- ",this.state);
    /* / TEMP DEMO CODE */

    /* Set Default Permissions */
    this.setDefaultStatePermissionVars();
  }

  nzTabPosition = 'top';
  selectedIndex = 0;

  percentCompleted: number = 60;

  showLastComment: boolean = false;

  /* tslint:disable-next-line:no-any */
  log(args: any[]): void {
    console.log(args);
  }

  ngOnInit(): void {
  }

  /* Variables */
  dataSet = [ {},{} ];

  showConfirm(toStage:string): void {
    this.modalService.confirm({
      nzTitle: `<i>Are you sure you want to reverse to ${toStage}?</i>`,
      nzContent: '<b>This action cannot be undone!</b>',
      nzOkText: "Reverse",
      nzOnOk: () => console.log('OK')
    });
  }

  /* Police Station Details */
  hasPoliceStnDetails:boolean = true;

  /* Nominee Same as Claimant ? */
  claimantSameAsNominee:boolean = true;

  /* PANELS */

  notesPanelOpen = false;
  notesPanel(status){ this.notesPanelOpen = !!status }

  policyPanelOpen = false;
  policyPanel(status){ this.policyPanelOpen = !!status }

  profilePanelOpen = false;
  profilePanel(status){ this.profilePanelOpen = !!status }

  corresPanelOpen = false;
  corresPanel(status){ this.corresPanelOpen = !!status }

  docuPanelOpen = false;
  docuPanel(status){ this.docuPanelOpen = !!status }

  worksheetPanelOpen = false;
  worksheetPanel(status){ this.worksheetPanelOpen = !!status }

  workflowPanelOpen = false;
  showDropdown:boolean|number = false;
  workflowPanel(status, showDropdown=0){
    this.showDropdown = showDropdown;
    this.workflowPanelOpen = !!status;
  }

  pendingPanelOpen = false;
  pendingPanel(status){ this.pendingPanelOpen = !!status }

  /* Investigator modal */
  modInvtgVis:boolean = false;

  note:string = '';
  noteCannedReply(indx:number) {
    switch(indx) {
      case 0: this.note = 'Please have a look at the ';
            break;
      case 1: this.note = 'Requesting additional investigation for ';
            break;
      case 2: this.note = 'Required Documents are not in place. Kindly do a through verification for ';
            break;
    }
  }

  /* Star */
  isStarred:boolean = false;
  /* Demo case --- only "adding" is shown */
  starThis() {
    this.message.loading('Adding to starred items', { nzDuration: 1200 });
    setTimeout(()=>{
      this.message.success('#CLM0000107 added to you starred items', { nzDuration: 1200 });
      this.isStarred = true;
    }, 1200);
  }

  /* Rich Text Editor */
  modalCorrespNew:boolean = false;
  openCorrModal(){
    this.modalCorrespNew = true;
    this.corresPanel(0); //Close corresp panel (z index error fix)
  }
  correspondenceSubject: string = `Information regarding your proposal %proposal_number%: Missing Documents`;
  correspondenceRichText:any = `
  <p>Dear %claimant_name%,</p>
  <br>
  <p>We request you to submit the death certificate for %lifeassured_name% at your earliest convenience.</p>
  <p>This would help us process your claim </p>
  <br>
  <p>Thank you,</p><br>
  <p>Team StandardLife</p>
  `;

  replacementArray:any = [
      {key: "Claimant Name", value: '%claimant_name%'},
      {key: "Claim Number", value: '%claim_number%'},
      {key: "Life-Assured Name", value: '%lifeassured_name%'},
      {key: "Missing Documents List", value: '%missing_documents%'},
  ];
    replacementSelected: any = null;
    replacementSelectedKaValue: any = null;
    replacementSelect(i) {
        this.replacementSelectedKaValue = i;
    }

  handleFileUpload(data) {
    //DUMMY: Check ngzorro UPLOAD component's documentation for implementation sample
    console.log(data);
  }

  correspType:string = "email";
  modSubmit:boolean = false;

  defaultUploadsList:any = [
    {
      uid: 1,
      name: 'SCAN001_CRT.pdf',
      status: 'done',
      url: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456',
      thumbUrl: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456'
    },
    {
      uid: 2,
      name: 'SCAN007_CRT2.pdf',
      status: 'done',
      url: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg',
      thumbUrl: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg'
    }
  ];
  showUploadList:any;

  uploadArray = [
    {id:1,name:"Birth Certificate [Required]",reqName:"Birth Certificate"},
    {id:2,name:"General Checkup Result [Required]",reqName: "Checkup Result"},
  ];
  addUploadRow() {
  let objPush = {id:3,name:"Additional Proof",reqName:"Additional Proof"};
  this.uploadArray.push(objPush)
  }
  removeUploadRow(){
    this.uploadArray.pop();
  }

  /* Event Type */
  eventType: string = "Death";


  /* Search by Customer or Policy */
  searchCustOrPolicy:string = "customer";
  searchCustOrPolicyLoading:boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }

  modSearchCustOrPolicy:boolean = false;

  showCustomerPolicies:boolean = false;
  showCustomerPoliciesName:string = '';
  viewAddCustomersPolicies(namePassed) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = namePassed;
  }

  modSearchCustomer:boolean = false;
  modSearchCustomerIDVerif:boolean = true;
  searchAddCustomer = 'search-customer';

  /* Open Modal and set to second tab (add customer) */
  editCustomerDetails() {
    this.modalSearchCustomer(true);
    setTimeout(()=>{this.searchAddCustomer = "add-customer"},250);
  }

  /* Open/Close Search Or Add CUSTOMER */
  modalSearchCustomer(state,showIDVerification=true){
    this.modSearchCustomer = state;
    this.modSearchCustomerIDVerif = showIDVerification;
  }

  modRejectIntimation:boolean = false;

  /* Hospital --- NEW */
  selectedHosp:any = "A";
  modHospitalizationDetails: boolean = false;
  modSearchAddHosp: boolean = false;
  modSearchAddDoctor: boolean = false;

  /* Hospital Tabs: Hide/Show */
  tabHosp:any = "search-hosp";
  /* Doctor Tabs: Hide/Show */
  tabDoc:any = "search-doc";

  /* ERRORS ==== */
  hasServerExceptions:boolean = false;
  hasTabBasicError:boolean = false;
  setErrorState(state:boolean) {
    if(state) {
      this.message.loading('Saving', { nzDuration: 1000 });
      setTimeout(()=>{
        this.message.error('Form has errors. Please fix to continue', { nzDuration: 3000 });
        this.hasServerExceptions = state;
        this.fakeValidationStatus = 'error';
        this.hasTabBasicError = true;
      }, 1000);
    }
    else {
      this.hasServerExceptions = state;
      this.fakeValidationStatus = null;
      this.hasTabBasicError = false;
    }
  }

  /* Error Panel */
  errPanelOpen: boolean = false;
  errPanelCollapsed: boolean = false;
  errDetailsPanel(state) { this.errPanelOpen = !!state }
  errorPanelToggle() {
    //Expand/collapse visible error panel
    this.errPanelCollapsed = !this.errPanelCollapsed;
  }

  /* Jump To Tab, Highlight field */
  fakeValidationStatus:any = null;
  errJumpTo(tabIndex:number, fieldToHighlight:string) {
    /* Auto-close panel ?*/
    this.errPanelOpen = false;
    /* Process */
    setTimeout(()=>{
      /* Switch Tab */
      this.selectedIndex = tabIndex;
    }, 250);
    setTimeout(()=>{
      /* Focus on Field */
    }, 500);
  }


  /* BENEFITS */
  /* VARS. FOR DEMO ONLY -- MAKE INTO ARRAY DURING ACTUAL CODING PHASE */
  tempBenefit1:string = `250000`;
  tempBenefit2:string = `20000`;
  tempBenefit3:string = `350000`;
  tempBenefitTotal:string = `150000`;

  updateBenefitTotal() {
    let sum:number = parseInt(this.tempBenefit1) + parseInt(this.tempBenefit2) + parseInt(this.tempBenefit3);
    this.tempBenefitTotal = sum.toString();
    console.log(this.tempBenefitTotal);
    this.computeBreakup();
  }

  /* PAYOUT / PAYMENT BREAKUP */
  advancePremium: any = -20000;
  outstandingPremium: any = -20000;
  totalPayoutAmt: string = '110000';
  computeBreakup() {
    let total = ( parseInt(this.tempBenefitTotal) + this.advancePremium + this.outstandingPremium );
    this.totalPayoutAmt = total.toString();
    this.updatePayoutNominee(total);
  }

  payoutNom1: any = '50000';
  payoutNom2: any = '50000';
  payoutNomTotal: any = '100000';
  updatePayoutNominee(total?){
    let numberOfNominees = 2;
    if(total) {
      this.payoutNom1 = (total/numberOfNominees).toString();
      this.payoutNom2 = (total/numberOfNominees).toString();
    }
  }

  /* Investigation */
  investiVerdict: string = "A";

  fileListIDProof = [{
    uid: 132802,
    name: 'pancard_scan_02308561.png',
    status: 'done',
    url: "https://taxguru.in/wp-content/uploads/2016/07/New-pancard-design.png"
  }];

  /* Handle State Changes -- Shows a fake loader for x seconds, and changes variables */
  handleStateChange(newState, processData:boolean = true) {
    let fakeTime = 800;
    this.message.loading('Updating view ...', { nzDuration: fakeTime });
    setTimeout(()=>{
      this.message.success('Loaded '+newState.charAt(0).toUpperCase() + newState.slice(1)+' view', { nzDuration: fakeTime+200 });
      if(processData) this.processStateVars(newState);
    }, fakeTime);
  }

  /* Set defaults for permissions onLoad and also reset when state value changes */
  setDefaultStatePermissionVars(){
    this.permissions = {
      /* ---- CLAIMS */
      basic: {show:true, edit:true},
      insured: {show:true, edit:true},
      nominee_claimant: {show:true, edit:true},
      hospitalization: {show:true, edit:true},
      bank_details: {show:true, edit:true},
      benefit: {show:false, edit:false},
      payment_breakup: {show:false, edit: false},
      payout_details: {show:true, edit: true},
      bill_details: {show:false, edit: true}, // for HEALTH claims
      adj_claim_decision: {show:false, edit:false},
      investigation_report: {show:false, edit:false},
      other_policies: {show:false, edit:false},
      analytics: {show:false, edit:false},
      /* ---- UNDERWRITING */
      uw_questionnaire: {show: true, edit: true },
      uw_auto_rules: {show: true, edit: true },
      uw_plan: {show: true, edit: true },
      uw_members: {show: true, edit: true },
      uw_insured: {show: true, edit: true },
      uw_coverages: {show: true, edit: true },
      uw_premium: {show: true, edit: true },
      uw_tnc: {show: true, edit: true },
    };
    /* Set other defaults */
    this.showLastComment = false;
  }

  /* Set the new state & permissions */
  processStateVars(state) {

    this.state = state; // set state
    this.stateName = state.charAt(0).toUpperCase() + state.slice(1); //Proper State Name (capitalized)

    /* For Claims: Set new permissions accordingly */
    if(this.productTypeConfig.productType=='claims') {

      this.setDefaultStatePermissionVars(); //set default permissions (resets all, if we missed out anything)

      switch (state) {
        case 'intimation':
          // Do nothing, as the defaults have been set already
          this.percentCompleted = 0;
          break;
        case 'registration':
          this.percentCompleted = 30;
          break;
        case 'adjudication':
          this.permissions.bank_details = {show: true, edit: true};
          this.permissions.benefit = {show: true, edit: true};
          this.permissions.payment_breakup = {show: true, edit: true};
          this.permissions.adj_claim_decision = {show: true, edit: true};
          this.permissions.analytics = {show: false, edit: true};
          this.permissions.bill_details = {show: true, edit: true}; // for HEALTH claims
          this.percentCompleted = 60;
          break;
        case 'investigation':
          this.toggleAllTabs('show', false);
          this.permissions.investigation_report = {show: true, edit: true}; // to show first
          this.permissions.basic = {show: true, edit: false};
          this.permissions.insured = {show: true, edit: false};
          this.permissions.nominee_claimant = {show: true, edit: false};
          this.permissions.hospitalization = {show: true, edit: false};
          this.permissions.bank_details = {show: false, edit: false};
          this.permissions.payout_details = {show: false, edit: false};
          this.permissions.other_policies = {show: true, edit: true};
          this.permissions.analytics = {show: false, edit: false};
          this.permissions.bill_details = {show: true, edit: false}; // for HEALTH claims
          this.selectedIndex = 0; //Reset Tab
          this.percentCompleted = 80;
          this.showLastComment = true;
          break;
        case 'payout':
          this.permissions.payment_breakup = {show: true, edit: true};
          this.permissions.analytics = {show: false, edit: true};
          this.permissions.bill_details = {show: true, edit: true}; // for HEALTH claims
          this.percentCompleted = 90;
          break;
        default:
          //Do nothing
          break;
      }
    }

    /* For Underwriting */
    else if(this.productTypeConfig.productType=='underwriting') {
      //this.toggleAllTabs('show', false);
      this.permissions.uw_auto_rules = {show:true, edit:true};
      this.permissions.uw_questionnaire = {show:true, edit:true};
      this.permissions.uw_plan = {show:true, edit:true};
      this.permissions.uw_members = {show:true, edit:true};
      this.permissions.uw_insured = {show:true, edit:true};
      this.permissions.uw_coverages = {show:true, edit:true};
      this.permissions.uw_premium = {show:true, edit:true};
      this.permissions.uw_tnc = {show:true, edit:true};
    }

  }

  /* Freeze */
  caseIsFrozen: boolean = false;
  freezeToggle() {
    /* Message */
    if(this.caseIsFrozen) this.message.loading('Unfreezing case ...', { nzDuration: 1200 });
    else this.message.loading('Freezing case', { nzDuration: 1200 });
    /* Toggle */
    this.caseIsFrozen = !this.caseIsFrozen;
    /* Set vars */
    if(this.caseIsFrozen) {
      for (let key in this.permissions) {
        if (this.permissions.hasOwnProperty(key)) {
          //this.permissions[key].show = false;
          this.permissions[key].edit = false;
        }
      }
    }
    else
      this.processStateVars(this.state);
  }

  /* Toggle All Tabs */
  toggleAllTabs(k:string,v:boolean) {
    for (let keyNm in this.permissions) {
      this.permissions.hasOwnProperty(keyNm)?this.permissions[keyNm][k]=v : null;
    }
  }

  /* Analytics */
  analyticsModal: boolean = false;


  /* PRODUCT Switcher -- Set Product Defaults here */
  switchProduct(type) {
    switch(type.toLowerCase()) {
      case 'underwriting-health':
        this.productTypeConfig = {
          productType: "underwriting",
          productTypeNicename: "Underwriting",
          prodSubType: "Health Proposal",
          prodTagColor: "#2cb12b",
          prodTagIcon: 'heart',
        };
        break;
      case 'claims-life':
        this.productTypeConfig = {
          productType: "claims",
          productTypeNicename: "Claim",
          prodSubType: "Death Claim",
          prodTagColor: "#333",
          prodTagIcon: 'heart',
        };
        break;
      case 'claims-health':
        this.productTypeConfig = {
          productType: "claims",
          productTypeNicename: "Claim",
          prodSubType: "Health Claim",
          prodTagColor: "#6ab112",
          prodTagIcon: 'medicine-box',
        };
        break;
    }
    this.handleStateChange(type,false);
  }


  /* Canned Replies Modal */
  cannedModal: boolean = false;

  /* UW */
  sumInsured:any = 100000;

  /* Date Issue Fix */
  d1:any; d2:any;
  handleDateChangeD1(dt:Date) { this.d1 = new Date(dt.toDateString()) }
  handleDateChangeD2(dt:Date) { this.d2 = new Date(dt.toDateString()) }

}
